import React from 'react';
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import {CardElement} from '@stripe/react-stripe-js';
import CheckoutForm from './CheckOutForm';
import './Payment.css';

const stripePromise = loadStripe('pk_test_51IiLH5DuxfvNjvUO1uzHCAhuD5awVFC1BXzgYvkc7mlPqDcE0VPkGwzlbL2QaoE58uTb7hNEEyQA9OHjeTTeAoRR00KihuKRQT');

const Payment = () => {
  return (
    <Elements stripe={stripePromise}>
       
        <CheckoutForm></CheckoutForm>

    </Elements>
  );
};

export default Payment;